import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => ({
  trackConditionsContainer: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%"
  },
  trackConditionsSubHeader: {
    position: "sticky",
    height: 40,
    backgroundColor: "#f6fbfa",
    zIndex: 1,
    boxShadow: "0px 1px 5px 0px rgba(0, 0, 0, 0.1)",
    [theme.breakpoints.up(Breakpoints.SX_720)]: {
      display: "none"
    }
  },
  trackConditionsBody: {
    display: "flex",
    height: "100%",
    [theme.breakpoints.down(600)]: {
      flexDirection: "column",
      overflow: "auto"
    }
  },
  tabulator: {
    boxShadow: "0px 1px 5px 0px rgba(0, 0, 0, 0.1)",
    display: "flex",
    justifyContent: "center",
    minHeight: "40px !important"
  },
  tabItem: {
    flexBasis: "50%",
    "&.Mui-selected": {
      color: theme.palette.secondary.dark
    },
    "&.MuiTab-root": {
      fontSize: 16,
      paddingBottom: 0,
      textTransform: "none",
      minHeight: 40
    }
  },
  facilitySelector: {
    "&.Mui-disabled": {
      "& .MuiSelect-icon": {
        opacity: 0.5
      }
    },
    "&.MuiInput-underline": {
      "&::after": {
        border: "none"
      }
    },
    "&.MuiInputBase-root": {
      "&.Mui-disabled": {
        "&::before": {
          borderBottomStyle: "none"
        }
      }
    },
    "& .MuiSelect-select": {
      paddingRight: 24,
      paddingLeft: 24,
      color: theme.palette.secondary.dark,
      "&.Mui-disabled": {
        opacity: 0.5,
        "& .MuiSelect-icon": {
          opacity: 0.5
        }
      },
      "&:focus": {
        backgroundColor: "unset"
      }
    },
    "&::before": {
      border: "none"
    },
    "&:hover": {
      "&.MuiInput-underline": {
        "&::before": {
          border: "none"
        }
      }
    },
    "& .MuiSelect-icon": {
      color: theme.palette.secondary.dark
    }
  },
  menuItem: {},
  menuItemText: {},
  regularTabButton: {
    whiteSpace: "nowrap"
  },
  opacityOverlay: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: theme.palette.common.white,
    opacity: 0.5,
    zIndex: 100
  },
  noDataHolder: {
    height: "100%",
    display: "flex",
    justifyContent: "center"
  },
  noDataHolderText: {
    marginTop: 50,
    fontSize: "20px",
    color: theme.palette.text.hint
  },
  contentBodyList: {
    height: "calc(100dvh - 205px)",
    overflowY: "auto"
  },
  buttonsGroup: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "10px 66px 14px 60px",
    borderTop: `1px solid ${theme.palette.text.hint}`,
    [theme.breakpoints.down("md")]: {
      padding: "14px 40px 20px 34px",
      position: "sticky",
      bottom: 0,
      zIndex: 1,
      backgroundColor: "#f6fbfa"
    },
    [theme.breakpoints.down("sm")]: {
      padding: "10px 24px 24px 18px"
    }
  },
  cancelButton: {
    marginRight: 16,
    height: 46,
    width: 140,
    "&.Mui-disabled": {
      color: theme.palette.text.disabled,
      backgroundColor: "#eeeeee",
      border: "none",
      "& .MuiTypography-root": {
        color: theme.palette.text.disabled
      }
    }
  },
  cancelButtonText: {
    fontSize: 16,
    color: theme.palette.text.secondary,
    [theme.breakpoints.down("sm")]: {
      fontSize: 14
    }
  },
  contentBodyLeft: {
    flexGrow: 1,
    borderRight: `1px solid ${theme.palette.text.hint}`,
    display: "flex",
    flexDirection: "column",
    position: "relative"
  },
  contentBodyRight: {
    flexBasis: "40%",
    maxHeight: "calc(100dvh - 116px)",
    overflowY: "auto"
  },
  saveButton: {
    maxWidth: 210,
    backgroundColor: theme.palette.secondary.dark,
    flexGrow: 1,
    border: "none",
    "&:hover": {
      backgroundColor: "#7ad8b3"
    },
    "&.Mui-disabled": {
      color: theme.palette.text.disabled,
      backgroundColor: "#eeeeee",
      border: "none",
      "& .MuiTypography-root": {
        color: theme.palette.text.disabled
      }
    },
    "& .MuiCircularProgress-root": {
      color: "white"
    }
  },
  saveButtonText: {
    fontSize: 16,
    color: theme.palette.common.white,
    [theme.breakpoints.down("sm")]: {
      fontSize: 14
    }
  },
  unsavedChangesModal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  unsavedPaper: {
    padding: "16px 20px",
    width: 350,
    height: 156,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    borderRadius: "4px",
    "&:focus": {
      outline: "none"
    }
  },
  unsavedHeader: {
    fontSize: 20,
    color: theme.palette.text.primary,
    marginBottom: 12
  },
  unsavedBody: {
    fontSize: 14,
    color: theme.palette.text.secondary,
    marginBottom: 12
  },
  unsavedFooter: {
    display: "flex",
    justifyContent: "space-between"
  },
  unsavedFooterLeft: {},
  unsavedFooterRight: {},
  swipeContainer: {
    height: "100%",
    "& .react-swipeable-view-container": {
      height: "100%"
    }
  },
  swipeElement: {
    display: "flex",
    flexDirection: "column"
  },
  unsavedButton: {
    fontSize: 16
  },
  unsavedDontSaveButtonText: {
    color: "#1a1a1a"
  },
  unsavedCancelButtonText: {
    color: theme.palette.text.secondary
  },
  unsavedSaveButtonText: {
    color: theme.palette.secondary.dark
  },
  hiddenSlide: {
    visibility: "hidden"
  },
  errorMessageLink: {
    color: theme.palette.common.white
  }
}));
